import { enableES5 } from 'immer'

/**
 * Must run before `@reduxjs/toolkit` uses Immer (see `store.ts` + `index.tsx` + `setupTests.ts`).
 * Vite keeps a single `immer` copy (`resolve.dedupe` + same chunk as RTK) so this registers for Toolkit too.
 */
enableES5()
